<!--/ FILTER BAR -->
<div class="filter-bar container" (document:click)="closeAllDropdowns()" (click)="$event.stopPropagation()">
    <div class="row">
        <div class="left-col col-12 col-lg-2">
            <div class="filter-group object-count-filter-group text-center">
                <div class="object-count pb-0 row">

                    <div class="project-count" [class.dual]="showPurchaseOrderCount">
                        <h3>{{ projectCountLabel }}</h3>
                        <p class="project-count">{{ projectCount }}</p>
                    </div>

                    <div class="pos-count" *ngIf="showPurchaseOrderCount">
                        <h3>{{ purchaseOrderCountLabel }}</h3>
                        <p class="pos-count">{{ purchaseOrderCount }}</p>
                    </div>

                    <div class="reset-button">
                        <p class="reset-filters"><a class="reset-filters" href="#" (click)="$event.preventDefault(); resetFilters()">Reset Filters</a>
                        </p>
                    </div>

                </div>
            </div>
        </div>
        <div class="right-col col-12 col-lg-10">
            <div class="row align-items-center">
                <!--# Global Search Field -->
                <div class="dropdown-group col-12 col-lg-4 mb-2" *ngIf="showSearchField">
                    <input type="text" class="dropdown-toggle filter-dropdown search-input" [ngClass]="{'has-content': searchTerm && searchTerm.length > 0}" placeholder="Search all fields..." [value]="searchTerm" (input)="onSearchInput($event)">
                </div>

                <!--# Fiscal Year Filter -->
                <div class="dropdown-group dropup col-4 col-md-3 col-lg-3 col-xl-2" style="position:relative;" *ngIf="showFiscalYearFilter">
                    <button id="fyDropdown" type="button" class="dropdown-toggle filter-dropdown" [ngClass]="{'active': selectedFiscalYears.length > 0}" (click)="$event.stopPropagation(); toggleDropdown('fy')">
                        <span class="long">Fiscal Year</span>
                        <span class="short">FY</span>
                        <span class="caret" [class.open]="dropdownOpen['fy']"></span>
                    </button>
                    <div class="dropdown-menu show" *ngIf="dropdownOpen['fy']">
                        <label *ngFor="let fy of fiscalYears" class="dropdown-item" [ngStyle]="{ 'font-weight': selectedFiscalYears.includes(fy) ? '700' : '400' }">
                            <input #fyDropdownBox type="checkbox" [checked]="selectedFiscalYears.includes(fy)" (change)="toggleFiscalYear(fy, fyDropdownBox.checked)" />
                            {{ fy }}
                        </label>
                    </div>
                </div>
                <div class="selected-pills" *ngIf="selectedFiscalYears.length > 0">
                    <span *ngFor="let fy of selectedFiscalYears" class="selected-pill" (click)="toggleFiscalYear(fy, false)">
                        <span class="remove-pill" title="Remove">&times;</span> {{ fy }}
                    </span>
                </div>

                <!--# Status Filter -->
                <div class="dropdown-group dropup col-4 col-md-3 col-lg-3 col-xl-2" style="position:relative;" *ngIf="showStatusFilter">
                    <button id="statusDropdown" type="button" class="dropdown-toggle filter-dropdown" [ngClass]="{'active': selectedStatuses.length > 0}" (click)="$event.stopPropagation(); toggleDropdown('status')">
                        ClickUp Status
                        <span class="caret" [class.open]="dropdownOpen['status']"></span>
                    </button>
                    <div class="dropdown-menu show" *ngIf="dropdownOpen['status']">
                        <label *ngFor="let status of statusOptions" class="dropdown-item" [ngStyle]="{ 'font-weight': selectedStatuses.includes(status) ? '700' : '400' }">
                            <input #statusDropdownBox type="checkbox" [checked]="selectedStatuses.includes(status)" (change)="toggleStatus(status, statusDropdownBox.checked)" />
                            {{ status }}
                        </label>
                    </div>
                </div>
                <div class="selected-pills" *ngIf="selectedStatuses.length > 0">
                    <span *ngFor="let status of selectedStatuses" class="selected-pill" (click)="toggleStatus(status, false)">
                        <span class="remove-pill" title="Remove">&times;</span> {{ status }}
                    </span>
                </div>

                <!--# Billing Status Filter -->
                <div class="dropdown-group dropup col-4 col-md-3 col-lg-3 col-xl-2" style="position:relative;" *ngIf="showBillingStatusFilter">
                    <button id="billingStatusDropdown" type="button" class="dropdown-toggle filter-dropdown" [ngClass]="{'active': selectedBillingStatuses.length > 0}" (click)="$event.stopPropagation(); toggleDropdown('billing')">
                        Billing Status
                        <span class="caret" [class.open]="dropdownOpen['billing']"></span>
                    </button>
                    <div class="dropdown-menu show" *ngIf="dropdownOpen['billing']">
                        <ng-container *ngIf="billingStatuses.length > 0; else noBilling">
                            <label *ngFor="let status of billingStatuses" class="dropdown-item" [ngStyle]="{ 'font-weight': selectedBillingStatuses.includes(status) ? '700' : '400' }">
                                <input #billingStatusBox type="checkbox" [checked]="selectedBillingStatuses.includes(status)" (change)="toggleBillingStatus(status, billingStatusBox.checked)" />
                                {{ status }}
                            </label>
                        </ng-container>
                        <ng-template #noBilling>
                            <div style="color:#888; padding: 0.5em;">No options</div>
                        </ng-template>
                    </div>
                </div>
                <div class="selected-pills" *ngIf="selectedBillingStatuses.length > 0">
                    <span *ngFor="let status of selectedBillingStatuses" class="selected-pill" (click)="toggleBillingStatus(status, false)">
                        <span class="remove-pill" title="Remove">&times;</span> {{ status }}
                    </span>
                </div>

                <!--# Parent Job Code Filter -->
                <div class="dropdown-group dropup parent-job-code-filter col-4 col-md-3 col-lg-3 col-xl-2" style="position:relative;" *ngIf="showParentJobCodeFilter">
                    <button id="parentJobCodeDropdown" type="button" class="dropdown-toggle filter-dropdown" [ngClass]="{'active': selectedParentJobCodes.length > 0}" (click)="$event.stopPropagation(); toggleDropdown('parentJobCode')">
                        Parent Job Code
                        <span class="caret" [class.open]="dropdownOpen['parentJobCode']"></span>
                    </button>
                    <div class="dropdown-menu show" *ngIf="dropdownOpen['parentJobCode']">

                        <!-- Defensive: Always render checkboxes for the union of parentJobCodes and selectedParentJobCodes to guarantee persistence -->

                        <!-- Using parentJobCodesUnion getter to ensure all selected and available codes are rendered as checkboxes -->
                        <label *ngFor="let code of parentJobCodesUnion" class="dropdown-item" [ngStyle]="{ 'font-weight': selectedParentJobCodes.includes(code) ? '700' : '400' }">
                            <input #parentJobCodeBox type="checkbox" [checked]="selectedParentJobCodes.includes(code)" (change)="toggleParentJobCode(code, parentJobCodeBox.checked)" />
                            {{ code }}
                        </label>
                    </div>
                </div>
                <div class="selected-pills" *ngIf="selectedParentJobCodes.length > 0">
                    <span *ngFor="let code of selectedParentJobCodes" class="selected-pill" (click)="toggleParentJobCode(code, false)">
                        <span class="remove-pill" title="Remove">&times;</span> {{ code }}
                    </span>
                </div>

                <!--# Buyer Filter -->
                <div class="dropdown-group dropup col-4 col-md-3 col-lg-3 col-xl-2" style="position:relative;" *ngIf="showBuyerFilter">
                    <button id="buyerDropdown" type="button" class="dropdown-toggle filter-dropdown" [ngClass]="{'active': selectedBuyers.length > 0}" (click)="$event.stopPropagation(); toggleDropdown('buyer')">
                        Buyer
                        <span class="caret" [class.open]="dropdownOpen['buyer']"></span>
                    </button>
                    <div class="dropdown-menu show" *ngIf="dropdownOpen['buyer']">
                        <label *ngFor="let buyer of buyers" class="dropdown-item" [ngStyle]="{ 'font-weight': selectedBuyers.includes(buyer) ? '700' : '400' }">
                            <input #buyerDropdownBox type="checkbox" [checked]="selectedBuyers.includes(buyer)" (change)="toggleBuyer(buyer, buyerDropdownBox.checked)" />
                            {{ buyer }}
                        </label>
                    </div>
                </div>
                <div class="selected-pills" *ngIf="selectedBuyers.length > 0">
                    <span *ngFor="let buyer of selectedBuyers" class="selected-pill" (click)="toggleBuyer(buyer, false)">
                        <span class="remove-pill" title="Remove">&times;</span> {{ buyer }}
                    </span>
                </div>

                <!--# Job Code Filter -->
                <div class="dropdown-group dropup job-code-filter col-4 col-md-3 col-lg-3 col-xl-2" style="position:relative;" *ngIf="showJobCodeFilter">
                    <button id="jobCodeDropdown" type="button" class="dropdown-toggle filter-dropdown" [ngClass]="{'active': selectedJobCodes.length > 0}" (click)="$event.stopPropagation(); toggleDropdown('jobCode')">
                        Job Code
                        <span class="caret" [class.open]="dropdownOpen['jobCode']"></span>
                    </button>
                    <div class="dropdown-menu show" *ngIf="dropdownOpen['jobCode']">
                        <label *ngFor="let code of jobCodes" class="dropdown-item" [ngStyle]="{ 'font-weight': selectedJobCodes.includes(code) ? '700' : '400' }">
                            <input #jobCodeDropdownBox type="checkbox" [checked]="selectedJobCodes.includes(code)" (change)="toggleJobCode(code, jobCodeDropdownBox.checked)" />
                            {{ code }}
                        </label>
                    </div>
                </div>
                <div class="selected-pills" *ngIf="selectedJobCodes.length > 0">
                    <span *ngFor="let code of selectedJobCodes" class="selected-pill" (click)="toggleJobCode(code, false)">
                        <span class="remove-pill" title="Remove">&times;</span> {{ code }}
                    </span>
                </div>

                <!--# PO Number Filter -->
                <div class="dropdown-group dropup col-4 col-md-3 col-lg-3 col-xl-2" style="position:relative;" *ngIf="showClientPoFilter">
                    <button id="poDropdown" type="button" class="dropdown-toggle filter-dropdown" [ngClass]="{'active': selectedClientPoNumbers.length > 0}" (click)="$event.stopPropagation(); toggleDropdown('po')">
                        PO Number
                        <span class="caret" [class.open]="dropdownOpen['po']"></span>
                    </button>
                    <div class="dropdown-menu show" *ngIf="dropdownOpen['po']">
                        <label *ngFor="let po of clientPoNumbers" class="dropdown-item" [ngStyle]="{ 'font-weight': selectedClientPoNumbers.includes(po) ? '700' : '400' }">
                            <input #poBox type="checkbox" [checked]="selectedClientPoNumbers.includes(po)" (change)="toggleClientPo(po, poBox.checked)" />
                            {{ po }}
                        </label>
                    </div>
                </div>
                <div class="selected-pills" *ngIf="selectedClientPoNumbers.length > 0">
                    <span *ngFor="let po of selectedClientPoNumbers" class="selected-pill" (click)="toggleClientPo(po, false)">
                        <span class="remove-pill" title="Remove">&times;</span> {{ po }}
                    </span>
                </div>

                <!--# Client Lead Filter -->
                <div class="dropdown-group dropup col-4 col-md-3 col-lg-3 col-xl-2" style="position:relative;" *ngIf="showClientLeadFilter">
                    <button id="clientLeadDropdown" type="button" class="dropdown-toggle filter-dropdown" [ngClass]="{'active': selectedClientLeads.length > 0}" (click)="$event.stopPropagation(); toggleDropdown('clientLead')">
                        Client Lead
                        <span class="caret" [class.open]="dropdownOpen['clientLead']"></span>
                    </button>
                    <div class="dropdown-menu show" *ngIf="dropdownOpen['clientLead']">
                        <label *ngFor="let lead of clientLeads" class="dropdown-item" [ngStyle]="{ 'font-weight': selectedClientLeads.includes(lead) ? '700' : '400' }">
                            <input #clientLeadDropdownBox type="checkbox" [checked]="selectedClientLeads.includes(lead)" (change)="toggleClientLead(lead, clientLeadDropdownBox.checked)" />
                            {{ lead }}
                        </label>
                    </div>
                </div>
                <div class="selected-pills" *ngIf="selectedClientLeads.length > 0">
                    <span *ngFor="let lead of selectedClientLeads" class="selected-pill" (click)="toggleClientLead(lead, false)">
                        <span class="remove-pill" title="Remove">&times;</span> {{ lead }}
                    </span>
                </div>

                <!--# Program Manager Filter -->
                <div class="dropdown-group dropup col-4 col-md-3 col-lg-3 col-xl-2" style="position:relative;" *ngIf="showProgramManagerFilter">
                    <button id="pmDropdown" type="button" class="dropdown-toggle filter-dropdown" [ngClass]="{'active': selectedProgramManagers.length > 0}" (click)="$event.stopPropagation(); toggleDropdown('programManager')">
                        <span class="long">Program Manager</span>
                        <span class="short">PM</span>
                        <span class="caret" [class.open]="dropdownOpen['programManager']"></span>
                    </button>
                    <div class="dropdown-menu show" *ngIf="dropdownOpen['programManager']">
                        <ng-container *ngIf="programManagers.length > 0; else noProgramManager">
                            <label *ngFor="let pm of programManagers" class="dropdown-item" [ngStyle]="{ 'font-weight': selectedProgramManagers.includes(pm) ? '700' : '400' }">
                                <input #pmDropdownBox type="checkbox" [checked]="selectedProgramManagers.includes(pm)" (change)="toggleProgramManager(pm, pmDropdownBox.checked)" />
                                {{ pm }}
                            </label>
                        </ng-container>
                        <ng-template #noProgramManager>
                            <div style="color:#888; padding: 0.5em;">No options</div>
                        </ng-template>
                    </div>
                </div>
                <div class="selected-pills" *ngIf="selectedProgramManagers.length > 0">
                    <span *ngFor="let pm of selectedProgramManagers" class="selected-pill" (click)="toggleProgramManager(pm, false)">
                        <span class="remove-pill" title="Remove">&times;</span> {{ pm }}
                    </span>
                </div>

                <!--# Engagement Lead Filter -->
                <div class="dropdown-group dropup col-4 col-md-3 col-lg-3 col-xl-2" style="position:relative;" *ngIf="showEngagementLeadFilter">
                    <button id="elDropdown" type="button" class="dropdown-toggle filter-dropdown" [ngClass]="{'active': selectedEngagementLeads.length > 0}" (click)="$event.stopPropagation(); toggleDropdown('engagementLead')">
                        <span class="long">Engagement Lead</span>
                        <span class="short">EL</span>
                        <span class="caret" [class.open]="dropdownOpen['engagementLead']"></span>
                    </button>
                    <div class="dropdown-menu show" *ngIf="dropdownOpen['engagementLead']">
                        <ng-container *ngIf="engagementLeads.length > 0; else noEngagementLead">
                            <label *ngFor="let el of engagementLeads" class="dropdown-item" [ngStyle]="{ 'font-weight': selectedEngagementLeads.includes(el) ? '700' : '400' }">
                                <input #elDropdownBox type="checkbox" [checked]="selectedEngagementLeads.includes(el)" (change)="toggleEngagementLead(el, elDropdownBox.checked)" />
                                {{ el }}
                            </label>
                        </ng-container>
                        <ng-template #noEngagementLead>
                            <div style="color:#888; padding: 0.5em;">No options</div>
                        </ng-template>
                    </div>
                </div>
                <div class="selected-pills" *ngIf="selectedEngagementLeads.length > 0">
                    <span *ngFor="let el of selectedEngagementLeads" class="selected-pill" (click)="toggleEngagementLead(el, false)">
                        <span class="remove-pill" title="Remove">&times;</span> {{ el }}
                    </span>
                </div>

                <!--# Project Type Filter -->
                <div class="dropdown-group dropup col-4 col-md-3 col-lg-3 col-xl-2" style="position:relative;" *ngIf="showProjectTypeFilter">
                    <button id="projectTypeDropdown" type="button" class="dropdown-toggle filter-dropdown" [ngClass]="{'active': selectedProjectTypes.length > 0}" (click)="$event.stopPropagation(); toggleDropdown('projectType')">
                        Project Type
                        <span class="caret" [class.open]="dropdownOpen['projectType']"></span>
                    </button>
                    <div class="dropdown-menu show" *ngIf="dropdownOpen['projectType']">
                        <ng-container *ngIf="projectTypes.length > 0; else noProjectType">
                            <label *ngFor="let pt of projectTypes" class="dropdown-item" [ngStyle]="{ 'font-weight': selectedProjectTypes.includes(pt) ? '700' : '400' }">
                                <input #ptDropdownBox type="checkbox" [checked]="selectedProjectTypes.includes(pt)" (change)="toggleProjectType(pt, ptDropdownBox.checked)" />
                                {{ pt }}
                            </label>
                        </ng-container>
                        <ng-template #noProjectType>
                            <div style="color:#888; padding: 0.5em;">No options</div>
                        </ng-template>
                    </div>
                </div>
                <div class="selected-pills" *ngIf="selectedProjectTypes.length > 0">
                    <span *ngFor="let pt of selectedProjectTypes" class="selected-pill" (click)="toggleProjectType(pt, false)">
                        <span class="remove-pill" title="Remove">&times;</span> {{ pt }}
                    </span>
                </div>

                <!--# Job Type Filter -->
                <div class="dropdown-group dropup col-4 col-md-3 col-lg-3 col-xl-2" style="position:relative;" *ngIf="showJobTypeFilter">
                    <button id="jobTypeDropdown" type="button" class="dropdown-toggle filter-dropdown" [ngClass]="{'active': selectedJobTypes.length > 0}" (click)="$event.stopPropagation(); toggleDropdown('jobType')">
                        Job Type
                        <span class="caret" [class.open]="dropdownOpen['jobType']"></span>
                    </button>
                    <div class="dropdown-menu show" *ngIf="dropdownOpen['jobType']">
                        <ng-container *ngIf="jobTypes.length > 0; else noJobType">
                            <label *ngFor="let jt of jobTypes" class="dropdown-item" [ngStyle]="{ 'font-weight': selectedJobTypes.includes(jt) ? '700' : '400' }">
                                <input #jtDropdownBox type="checkbox" [checked]="selectedJobTypes.includes(jt)" (change)="toggleJobType(jt, jtDropdownBox.checked)" />
                                {{ jt }}
                            </label>
                        </ng-container>
                        <ng-template #noJobType>
                            <div style="color:#888; padding: 0.5em;">No options</div>
                        </ng-template>
                    </div>
                </div>
                <div class="selected-pills" *ngIf="selectedJobTypes.length > 0">
                    <span *ngFor="let jt of selectedJobTypes" class="selected-pill" (click)="toggleJobType(jt, false)">
                        <span class="remove-pill" title="Remove">&times;</span> {{ jt }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</div>